export default __webpack_public_path__ + "static/media/pin.97a306c7.svg";